import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { setUserGuideToggle } from '../../../redux/reducers/userGuideReducer';
export const projectsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.activeProjects',
        popover: {
          title: 'Active Projects',
          description:
            'This section displays all ongoing projects. You can monitor their progress, assign tasks, and ensure everything stays on track.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.completedProjects',
        popover: {
          title: 'Completed Projects',
          description:
            'Here you can review all completed projects. Analyze outcomes, review documentation, and close out tasks as necessary.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.projectsDetails',
        popover: {
          title: 'Project Details',
          description:
            'View detailed information about each project, including timelines, tasks, and team members involved. Use this to manage and track project specifics.',
          side: 'top',
          align: 'end',
          onNextClick: () => {
            console.log('checking___76');
            dispatch(setUserGuideToggle());
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default projectsDriverObj;
